@for (asset of assets; track asset; let idx = $index) { @if (currentIndex === idx) {
<div #container class="zoom-image-container" [tabindex]="scale === 1 ? -1 : 0" (keydown)="onKeyDown($event)">
    @if (!highQualityLoaded) {
    <img
        #imageZoomContainer
        class="zoom-image"
        hI18nAsset
        [tag]="asset.tag"
        [imageTitle]="product.title"
        [url]="asset.url"
        [hI18nAttr]="'alt'"
        alt=""
        [ngStyle]="{ transform: transforms }"
        [attr.srcset]="getImageSrc(asset.url, asset.source, size * 2, imgLowQualityLevel)"
        [attr.src]="getImageSrc(asset.url, asset.source, size * 2, imgLowQualityLevel)"
        [style.transform]="transform$ | async"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (load)="handleLowQualityLoaded()" />
    }

    <img
        #imageZoomContainer
        class="zoom-image"
        hI18nAsset
        [tag]="asset.tag"
        [imageTitle]="product.title"
        [url]="asset.url"
        [hI18nAttr]="'alt'"
        alt=""
        [ngStyle]="{
            transform: transforms,
            width: highQualityLoaded ? 'auto' : '0%',
            opacity: highQualityLoaded ? 1 : 0
        }"
        [attr.srcset]="getImageSrc(asset.url, asset.source, size * 2, imgHighQualityLevel)"
        [attr.src]="getImageSrc(asset.url, asset.source, size * 2, imgHighQualityLevel)"
        [style.transform]="transform$ | async"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (load)="handleHighQualityLoaded()" />
</div>
} }
